import { DateRangeType } from '@features/dashboard/types';

const convertDashboardDateRangeToIso = (dateRange: DateRangeType) => {
  if (!dateRange.startDate || !dateRange.endDate) {
    return { from: '', to: '' };
  }
  const [startDd, startMm, startYyyy] = dateRange.startDate.split('-');
  const [endDd, endMm, endYyyy] = dateRange.endDate.split('-');
  const from = new Date(
    Date.UTC(Number(startYyyy), Number(startMm) - 1, Number(startDd))
  ).toISOString();
  const to = new Date(
    Date.UTC(Number(endYyyy), Number(endMm) - 1, Number(endDd), 23, 59, 0)
  ).toISOString();
  return { from, to };
};

export default convertDashboardDateRangeToIso;
